module.exports = __webpack_public_path__ + "static/shoe-layer-1-1fccdeb95ce303b4e7d1a012a156b7f2.png";